import React from "react";
import { CircularProgress } from "@mui/material";

export function ImanCircularIndicator(props: { color?: "primary" | "secondary" }): JSX.Element {
    return <CircularProgress color={props.color ? props.color : "primary"} />;
}
